module.exports = __webpack_public_path__ + "static/img/middle2.9699424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/orgextension/middle2.jpg
// module id = 90Vz
// module chunks = 9